module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/178-palau-b359703780653ed08f4a28005c8a6306.svg";